 <div class="overlay" *ngIf="loading$ | async">
      <img src="assets/icons/loading.gif" alt="Loading..." />
    </div>